import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the languageToggle state domain
 */
const selectLanguage = state => state.get('language', initialState);

const selectApp = state => state.get('app', initialState);

/**
 * Select the language locale
 */

const makeSelectLocale = () =>
  createSelector(selectLanguage, languageState => languageState.get('locale'));

const makeSelectUser = () =>
  createSelector(selectApp, state => state.getIn(['user', 'data']));
export { selectLanguage, makeSelectLocale, makeSelectUser };
